export default __webpack_public_path__ + "assets/images/eb4ebd03826ce9edc1654fc6a08fa468.png";